const LINE_WIDTHS = ['w-full', 'w-full', 'w-11/12', 'w-4/5'];
const PARAGRAPH_COUNT = 6;

const RichTextEditorSkeleton = () => (
  <div className="w-full max-w-screen-lg space-y-6">
    {Array.from({ length: PARAGRAPH_COUNT }).map((_, paragraphIndex) => (
      <div key={paragraphIndex} className="space-y-2">
        {LINE_WIDTHS.map((width, lineIndex) => (
          <div key={lineIndex} className={`h-4 ${width} animate-pulse rounded bg-gray-200`} />
        ))}
      </div>
    ))}
  </div>
);

export default RichTextEditorSkeleton;
